import { env } from '@/env';

import type { LinkProps } from './Or2Link';
import { Or2Link } from './Or2Link';

type Props = { subject?: string } & Omit<LinkProps, 'href'>;

export const Or2SupportLink = ({ subject, children, ...otherProps }: Props) => {
  return (
    <Or2Link
      {...otherProps}
      href={`mailto:${env.NEXT_PUBLIC_SUPPORT_EMAIL}${subject ? `?subject=${subject}` : ''}`}
    >
      {children}
    </Or2Link>
  );
};
